export default "__VITE_ASSET__c2f6f6b3__"